



import React, {
  createContext,
  useContext,
  useState,
  useCallback,
  useRef,
  useEffect,
  ReactNode,
} from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Check, Coins, X } from "lucide-react";

export type CurrencyItem = {
  code: string;
  symbol: string;
  name: string;
};



export const CURRENCIES: CurrencyItem[] = [
  { code: "AED", symbol: "د.إ", name: "UAE Dirham" },
  { code: "AFN", symbol: "؋", name: "Afghan Afghani" },
  { code: "ALL", symbol: "L", name: "Albanian Lek" },
  { code: "AMD", symbol: "֏", name: "Armenian Dram" },
  { code: "ANG", symbol: "ƒ", name: "Netherlands Antillean Guilder" },
  { code: "AOA", symbol: "Kz", name: "Angolan Kwanza" },
  { code: "ARS", symbol: "$", name: "Argentine Peso" },
  { code: "AUD", symbol: "A$", name: "Australian Dollar" },
  { code: "AWG", symbol: "ƒ", name: "Aruban Florin" },
  { code: "AZN", symbol: "₼", name: "Azerbaijani Manat" },
  { code: "BAM", symbol: "KM", name: "Bosnia-Herzegovina Convertible Mark" },
  { code: "BBD", symbol: "Bds$", name: "Barbadian Dollar" },
  { code: "BDT", symbol: "৳", name: "Bangladeshi Taka" },
  { code: "BGN", symbol: "лв", name: "Bulgarian Lev" },
  { code: "BHD", symbol: ".د.ب", name: "Bahraini Dinar" },
  { code: "BIF", symbol: "FBu", name: "Burundian Franc" },
  { code: "BMD", symbol: "BD$", name: "Bermudan Dollar" },
  { code: "BND", symbol: "B$", name: "Brunei Dollar" },
  { code: "BOB", symbol: "Bs.", name: "Bolivian Boliviano" },
  { code: "BRL", symbol: "R$", name: "Brazilian Real" },
  { code: "BSD", symbol: "B$", name: "Bahamian Dollar" },
  { code: "BTN", symbol: "Nu.", name: "Bhutanese Ngultrum" },
  { code: "BWP", symbol: "P", name: "Botswanan Pula" },
  { code: "BYN", symbol: "Br", name: "Belarusian Ruble" },
  { code: "BZD", symbol: "BZ$", name: "Belize Dollar" },
  { code: "CAD", symbol: "C$", name: "Canadian Dollar" },
  { code: "CDF", symbol: "FC", name: "Congolese Franc" },
  { code: "CHF", symbol: "Fr", name: "Swiss Franc" },
  { code: "CLP", symbol: "$", name: "Chilean Peso" },
  { code: "CNY", symbol: "¥", name: "Chinese Yuan" },
  { code: "COP", symbol: "$", name: "Colombian Peso" },
  { code: "CRC", symbol: "₡", name: "Costa Rican Colón" },
  { code: "CUP", symbol: "$", name: "Cuban Peso" },
  { code: "CVE", symbol: "$", name: "Cape Verdean Escudo" },
  { code: "CZK", symbol: "Kč", name: "Czech Koruna" },
  { code: "DJF", symbol: "Fdj", name: "Djiboutian Franc" },
  { code: "DKK", symbol: "kr", name: "Danish Krone" },
  { code: "DOP", symbol: "RD$", name: "Dominican Peso" },
  { code: "DZD", symbol: "دج", name: "Algerian Dinar" },
  { code: "EGP", symbol: "£", name: "Egyptian Pound" },
  { code: "ERN", symbol: "Nfk", name: "Eritrean Nakfa" },
  { code: "ETB", symbol: "Br", name: "Ethiopian Birr" },
  { code: "EUR", symbol: "€", name: "Euro" },
  { code: "FJD", symbol: "FJ$", name: "Fijian Dollar" },
  { code: "FKP", symbol: "£", name: "Falkland Islands Pound" },
  { code: "GBP", symbol: "£", name: "British Pound" },
  { code: "GEL", symbol: "₾", name: "Georgian Lari" },
  { code: "GHS", symbol: "₵", name: "Ghanaian Cedi" },
  { code: "GIP", symbol: "£", name: "Gibraltar Pound" },
  { code: "GMD", symbol: "D", name: "Gambian Dalasi" },
  { code: "GNF", symbol: "FG", name: "Guinean Franc" },
  { code: "GTQ", symbol: "Q", name: "Guatemalan Quetzal" },
  { code: "GYD", symbol: "G$", name: "Guyanaese Dollar" },
  { code: "HKD", symbol: "HK$", name: "Hong Kong Dollar" },
  { code: "HNL", symbol: "L", name: "Honduran Lempira" },
  { code: "HTG", symbol: "G", name: "Haitian Gourde" },
  { code: "HUF", symbol: "Ft", name: "Hungarian Forint" },
  { code: "IDR", symbol: "Rp", name: "Indonesian Rupiah" },
  { code: "ILS", symbol: "₪", name: "Israeli New Shekel" },
  { code: "INR", symbol: "₹", name: "Indian Rupee" },
  { code: "IQD", symbol: "ع.د", name: "Iraqi Dinar" },
  { code: "IRR", symbol: "﷼", name: "Iranian Rial" },
  { code: "ISK", symbol: "kr", name: "Icelandic Króna" },
  { code: "JMD", symbol: "J$", name: "Jamaican Dollar" },
  { code: "JOD", symbol: "د.ا", name: "Jordanian Dinar" },
  { code: "JPY", symbol: "¥", name: "Japanese Yen" },
  { code: "KES", symbol: "KSh", name: "Kenyan Shilling" },
  { code: "KGS", symbol: "с", name: "Kyrgystani Som" },
  { code: "KHR", symbol: "៛", name: "Cambodian Riel" },
  { code: "KMF", symbol: "CF", name: "Comorian Franc" },
  { code: "KPW", symbol: "₩", name: "North Korean Won" },
  { code: "KRW", symbol: "₩", name: "South Korean Won" },
  { code: "KWD", symbol: "د.ك", name: "Kuwaiti Dinar" },
  { code: "KYD", symbol: "CI$", name: "Cayman Islands Dollar" },
  { code: "KZT", symbol: "₸", name: "Kazakhstani Tenge" },
  { code: "LAK", symbol: "₭", name: "Laotian Kip" },
  { code: "LBP", symbol: "ل.ل", name: "Lebanese Pound" },
  { code: "LKR", symbol: "Rs", name: "Sri Lankan Rupee" },
  { code: "LRD", symbol: "L$", name: "Liberian Dollar" },
  { code: "LSL", symbol: "L", name: "Lesotho Loti" },
  { code: "LYD", symbol: "ل.د", name: "Libyan Dinar" },
  { code: "MAD", symbol: "د.م.", name: "Moroccan Dirham" },
  { code: "MDL", symbol: "L", name: "Moldovan Leu" },
  { code: "MGA", symbol: "Ar", name: "Malagasy Ariary" },
  { code: "MKD", symbol: "ден", name: "Macedonian Denar" },
  { code: "MMK", symbol: "K", name: "Myanmar Kyat" },
  { code: "MNT", symbol: "₮", name: "Mongolian Tugrik" },
  { code: "MOP", symbol: "MOP$", name: "Macanese Pataca" },
  { code: "MRU", symbol: "UM", name: "Mauritanian Ouguiya" },
  { code: "MUR", symbol: "₨", name: "Mauritian Rupee" },
  { code: "MVR", symbol: "Rf", name: "Maldivian Rufiyaa" },
  { code: "MWK", symbol: "MK", name: "Malawian Kwacha" },
  { code: "MXN", symbol: "$", name: "Mexican Peso" },
  { code: "MYR", symbol: "RM", name: "Malaysian Ringgit" },
  { code: "MZN", symbol: "MT", name: "Mozambican Metical" },
  { code: "NAD", symbol: "N$", name: "Namibian Dollar" },
  { code: "NGN", symbol: "₦", name: "Nigerian Naira" },
  { code: "NIO", symbol: "C$", name: "Nicaraguan Córdoba" },
  { code: "NOK", symbol: "kr", name: "Norwegian Krone" },
  { code: "NPR", symbol: "₨", name: "Nepalese Rupee" },
  { code: "NZD", symbol: "NZ$", name: "New Zealand Dollar" },
  { code: "OMR", symbol: "﷼", name: "Omani Rial" },
  { code: "PAB", symbol: "B/.", name: "Panamanian Balboa" },
  { code: "PEN", symbol: "S/.", name: "Peruvian Sol" },
  { code: "PGK", symbol: "K", name: "Papua New Guinean Kina" },
  { code: "PHP", symbol: "₱", name: "Philippine Peso" },
  { code: "PKR", symbol: "₨", name: "Pakistani Rupee" },
  { code: "PLN", symbol: "zł", name: "Polish Złoty" },
  { code: "PYG", symbol: "₲", name: "Paraguayan Guarani" },
  { code: "QAR", symbol: "﷼", name: "Qatari Rial" },
  { code: "RON", symbol: "lei", name: "Romanian Leu" },
  { code: "RSD", symbol: "дин.", name: "Serbian Dinar" },
  { code: "RUB", symbol: "₽", name: "Russian Ruble" },
  { code: "RWF", symbol: "FRw", name: "Rwandan Franc" },
  { code: "SAR", symbol: "﷼", name: "Saudi Riyal" },
  { code: "SBD", symbol: "SI$", name: "Solomon Islands Dollar" },
  { code: "SCR", symbol: "₨", name: "Seychellois Rupee" },
  { code: "SDG", symbol: "ج.س.", name: "Sudanese Pound" },
  { code: "SEK", symbol: "kr", name: "Swedish Krona" },
  { code: "SGD", symbol: "S$", name: "Singapore Dollar" },
  { code: "SHP", symbol: "£", name: "Saint Helena Pound" },
  { code: "SLE", symbol: "Le", name: "Sierra Leonean Leone" },
  { code: "SOS", symbol: "Sh", name: "Somali Shilling" },
  { code: "SRD", symbol: "$", name: "Surinamese Dollar" },
  { code: "SSP", symbol: "£", name: "South Sudanese Pound" },
  { code: "STN", symbol: "Db", name: "São Tomé & Príncipe Dobra" },
  { code: "SYP", symbol: "£", name: "Syrian Pound" },
  { code: "SZL", symbol: "L", name: "Swazi Lilangeni" },
  { code: "THB", symbol: "฿", name: "Thai Baht" },
  { code: "TJS", symbol: "ЅМ", name: "Tajikistani Somoni" },
  { code: "TMT", symbol: "m", name: "Turkmenistani Manat" },
  { code: "TND", symbol: "د.ت", name: "Tunisian Dinar" },
  { code: "TOP", symbol: "T$", name: "Tongan Paʻanga" },
  { code: "TRY", symbol: "₺", name: "Turkish Lira" },
  { code: "TTD", symbol: "TT$", name: "Trinidad & Tobago Dollar" },
  { code: "TWD", symbol: "NT$", name: "New Taiwan Dollar" },
  { code: "TZS", symbol: "TSh", name: "Tanzanian Shilling" },
  { code: "UAH", symbol: "₴", name: "Ukrainian Hryvnia" },
  { code: "UGX", symbol: "USh", name: "Ugandan Shilling" },
  { code: "USD", symbol: "$", name: "US Dollar" },
  { code: "UYU", symbol: "$U", name: "Uruguayan Peso" },
  { code: "UZS", symbol: "сўм", name: "Uzbekistani Som" },
  { code: "VES", symbol: "Bs.S", name: "Venezuelan Bolívar" },
  { code: "VND", symbol: "₫", name: "Vietnamese Dong" },
  { code: "VUV", symbol: "VT", name: "Vanuatu Vatu" },
  { code: "WST", symbol: "T", name: "Samoan Tala" },
  { code: "XAF", symbol: "FCFA", name: "Central African CFA Franc" },
  { code: "XCD", symbol: "EC$", name: "East Caribbean Dollar" },
  { code: "XOF", symbol: "CFA", name: "West African CFA Franc" },
  { code: "XPF", symbol: "₣", name: "CFP Franc" },
  { code: "YER", symbol: "﷼", name: "Yemeni Rial" },
  { code: "ZAR", symbol: "R", name: "South African Rand" },
  { code: "ZMW", symbol: "ZK", name: "Zambian Kwacha" },
  { code: "ZWL", symbol: "$", name: "Zimbabwean Dollar" },
];




 
 
export interface PaymentMethodMeta {
  label: string;
  sub: string;
  enabled: boolean;
  key?: string;
  ep?: string;
  supportedCountries?: string[];
  providers?: PaymentProviderMeta[];   // <- now points to the new type
}
 
// Sub-providers (e.g. under Mobile Money) don't need sub/enabled —
// their availability/enabled state is controlled by the parent method.
export interface PaymentProviderMeta {
  key: string;
  label: string;
  ep: string;
  supportedCountries?: string[];
  hint?: string; // sample phone number shown as an input placeholder in the UI
}
 
export const PAYMENT_METHODS: Record<string, PaymentMethodMeta> = {
  MOOPAY: {
    label: "MOOLABLES",
    sub: "MOOLABLES",
    enabled: false,
    supportedCountries: ["KE","EE"],
  },
 
  CARD: {
    label: "Card Payment",
    sub: "Visa · Mastercard · Amex",
    enabled: true,
    // no supportedCountries -> globally available
  },
 
  MOBILE_MONEY: {
    label: "Mobile Money",
    sub: "M-Pesa ",
    enabled: false,
    providers: [
      { key: "mpesa",  label: "M-Pesa",       ep: "initiateMpesa",   supportedCountries: ["KE", "TZ","EE"], hint: "712 345 678" },
      { key: "momo",   label: "MTN MoMo",     ep: "initiateMtnMomo", supportedCountries: ["UG", "GH", "RW", "CM", "CI"], hint: "24 123 4567" },
      { key: "airtel", label: "Airtel Money", ep: "initiateAirtel",  supportedCountries: ["KE", "UG", "TZ", "ZM", "MW"], hint: "75 123 4567" },
      { key: "orange", label: "Orange Money", ep: "initiateOrange",  supportedCountries: ["SN", "CI", "CM", "ML"], hint: "77 123 45 67" },
    ],
  },
 
  GOOGLE_PAY: {
    label: "Google Pay",
    sub: "Saved Google cards",
    enabled: false,
  },
 
  APPLE_PAY: {
    label: "Apple Pay",
    sub: "Face ID · Touch ID",
    enabled: false,
    supportedCountries: [
      // Africa
      "EG", "MA", "ZA",
      // Asia-Pacific
      "AU", "CN", "HK", "JP", "MO", "MY", "MN", "NZ", "SG", "KR", "TW", "VN",
      // Europe
      "AL", "AD", "AM", "AT", "AZ", "BY", "BE", "BA", "BG", "HR", "CY", "CZ",
      "DK", "EE", "FO", "FI", "FR", "GE", "DE", "GR", "GL", "GG", "HU", "IS",
      "IE", "IM", "IT", "JE", "KZ", "XK", "LV", "LI", "LT", "LU", "MT", "MD",
      "MC", "ME", "NL", "MK", "NO", "PL", "PT", "RO", "SM", "RS", "SK", "SI",
      "ES", "SE", "CH", "UA", "GB", "VA",
      // Latin America & Caribbean
      "AR", "BS", "BR", "CL", "CO", "CR", "DO", "EC", "SV", "GT", "HN", "MX",
      "PA", "PY", "PE", "UY",
      // Middle East
      "BH", "IL", "JO", "KW", "OM", "PS", "QA", "SA", "AE",
      // North America
      "CA", "US", "PR",
    ],
  },
};
 
export type PayMethodKey = keyof typeof PAYMENT_METHODS;
export type ResolvedPaymentMethod = PaymentMethodMeta & { key: PayMethodKey };
 
export interface PaymentMethodsResult {
  methods: ResolvedPaymentMethod[];
  isEmpty: boolean;       // true if no methods matched this country
  fallbackUsed: boolean;  // true if we had to fall back to a default set
}

export function getPaymentMethodsForCountry(countryCode: string): PaymentMethodsResult {
  const resolve = (): ResolvedPaymentMethod[] =>
    Object.entries(PAYMENT_METHODS)
      .filter(([, method]) => method.enabled)
      .map(([key, method]) => {
        if (method.providers) {
          const providers = method.providers.filter(
            p => !p.supportedCountries || p.supportedCountries.includes(countryCode)
          );
          if (providers.length === 0) return null;
          return { key: key as PayMethodKey, ...method, providers };
        }
        if (method.supportedCountries && !method.supportedCountries.includes(countryCode)) {
          return null;
        }
        return { key: key as PayMethodKey, ...method };
      })
      .filter((m): m is ResolvedPaymentMethod => m !== null);
 
  const methods = resolve();
 
  if (methods.length > 0) {
    return { methods, isEmpty: false, fallbackUsed: false };
  }
 
  const fallback = Object.entries(PAYMENT_METHODS)
    .filter(([, m]) => m.enabled && !m.supportedCountries && !m.providers)
    .map(([key, method]) => ({ key: key as PayMethodKey, ...method }));
 
  return {
    methods: fallback,
    isEmpty: fallback.length === 0,
    fallbackUsed: true,
  };
}

export function getPaymentMethods(): ResolvedPaymentMethod[] {
  return Object.entries(PAYMENT_METHODS)
    .filter(([, method]) => method.enabled)
    .map(([key, method]) => ({ key: key as PayMethodKey, ...method }));
}
















export const CurrencyProvider = (() => {
  const CACHE_KEY = "appCurrency";
  const MANUAL_KEY = "appCurrencyManual";
  const CACHE_TTL_MS = 24 * 60 * 60 * 1000; // 24h

  type CurrencyOriginalEntry = { original: string; written: string };

  type CurrencyInfo = {
    code: string; // e.g. "USD"
    rate: number; // 1 EUR = `rate` units of `code`
  };

  type CurrencyContextValue = {
    currency: string; // "EUR" while still detecting, or if detection lands on EUR/fails
    rate: number; // 1 by default
    ready: boolean; // false until detection has resolved at least once
    convert: (eurAmount: number) => number;
    format: (eurAmount: number) => string;
  };

  const CurrencyContext = createContext<CurrencyContextValue | undefined>(undefined);

  type CurrencyListItem = { code: string; name: string; symbol: string };
  const RATES_CACHE_KEY = "appCurrencyRates"; // bulk EUR-based rates for ~160 currencies, one shared fetch
  const RATES_TTL_MS = 24 * 60 * 60 * 1000; // 24h
  const CURRENCY_LIST_CACHE_KEY = "appCurrencyList";
  const CURRENCY_LIST_TTL_MS = 7 * 24 * 60 * 60 * 1000; // names/symbols barely ever change — 7 days is plenty

  /** Derives the display symbol for a currency code from the browser's own Intl data —
   *  no hardcoded symbol table needed. Falls back to the code itself if Intl can't resolve it. */
  function symbolFor(code: string): string {
    try {
      const parts = new Intl.NumberFormat(navigator.language || "en-US", {
        style: "currency",
        currency: code,
        currencyDisplay: "symbol",
      }).formatToParts(1);
      return parts.find((p) => p.type === "currency")?.value ?? code;
    } catch {
      return code;
    }
  }

  /** Derives the human-readable currency name from the browser's own Intl data — again,
   *  no hardcoded name table. Intl.DisplayNames covers virtually every ISO 4217 code. */
  function displayNameFor(code: string): string {
    try {
      // @ts-ignore — Intl.DisplayNames is standard (ES2021+) but some TS lib configs lag behind.
      const dn = new Intl.DisplayNames([navigator.language || "en"], { type: "currency" });
      const name = dn.of(code);
      if (name && name.toUpperCase() !== code) return name;
    } catch {
      /* fall through */
    }
    return code;
  }

  /** One bulk fetch of EUR -> every currency open.er-api tracks (~160), cached 24h. This
   *  single request backs BOTH the exchange-rate lookups and the currency picker's list —
   *  far broader coverage than any single "official" reference-rate source offers, since
   *  it aggregates from multiple market sources rather than just the ECB's ~30. */
  async function loadAllRates(): Promise<Record<string, number>> {
    try {
      const raw = localStorage.getItem(RATES_CACHE_KEY);
      if (raw) {
        const parsed = JSON.parse(raw);
        if (parsed?.rates && typeof parsed.ts === "number" && Date.now() - parsed.ts < RATES_TTL_MS) {
          return parsed.rates;
        }
      }
    } catch {
      /* fall through to network */
    }
    try {
      const res = await fetch("https://open.er-api.com/v6/latest/EUR");
      const data = await res.json();
      const rates: Record<string, number> = data?.rates && typeof data.rates === "object" ? { ...data.rates } : {};
      rates.EUR = 1;
      try {
        localStorage.setItem(RATES_CACHE_KEY, JSON.stringify({ rates, ts: Date.now() }));
      } catch {
        /* ignore quota errors */
      }
      return rates;
    } catch {
      return { EUR: 1 }; // network failed entirely — at least don't break EUR
    }
  }

  /** Builds the full picker list from whatever open.er-api actually has rates for — no
   *  hand-typed or artificially limited list. Names/symbols come from Intl, not a table. */
  async function fetchCurrencyList(): Promise<CurrencyListItem[]> {
    try {
      const raw = localStorage.getItem(CURRENCY_LIST_CACHE_KEY);
      if (raw) {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed?.items) && typeof parsed?.ts === "number" && Date.now() - parsed.ts < CURRENCY_LIST_TTL_MS) {
          return parsed.items;
        }
      }
    } catch {
      /* fall through to network */
    }
    const rates = await loadAllRates();
    const codes = Object.keys(rates);
    if (!codes.includes("EUR")) codes.push("EUR");
    const items: CurrencyListItem[] = codes
      .map((code) => ({ code, name: displayNameFor(code), symbol: symbolFor(code) }))
      .sort((a, b) => a.name.localeCompare(b.name));
    try {
      localStorage.setItem(CURRENCY_LIST_CACHE_KEY, JSON.stringify({ items, ts: Date.now() }));
    } catch {
      /* ignore quota errors */
    }
    return items;
  }

  // Matches "€20", "€19.99", "€19,99", "€1,234.56" — always anchored on the €
  // symbol so it never touches unrelated numbers (credit counts, dates, etc.).
  const EURO_PRICE_RE = /€\s?(\d{1,3}(?:[.,]\d{3})*(?:[.,]\d{1,2})?)/g;

  const CQ = {
    ink: "#0A1464",
    blue: "#0180FC",
    body: "#4A5C99",
    chip: "#E8F3FF",
    sheet: "#EAF5FF",
    handle: "#B9D3EA",
    shadow: "rgba(10,20,100,.2)",
  };

  const CQ_CSS = `
.cq, .cq *, .cq *::before, .cq *::after{ box-sizing:border-box; font-family:'Inter',system-ui,sans-serif; }
.cq button{ cursor:pointer; border:none; background:none; font-family:inherit; color:inherit; }
.cq button:focus-visible{ outline:2px solid ${CQ.blue}; outline-offset:2px; }

.cq-tab-wrap{
  position:fixed; top:50%; left:0; z-index:9998;
  transform:translateY(-50%);
  touch-action:pan-y;
}
.cq-fab{
  display:flex; align-items:center; gap:6px;
  width:${`108px`}; height:38px; padding:0 14px 0 12px;
  border-radius:0 12px 12px 0;
  background:#fff; box-shadow:3px 3px 12px -4px ${CQ.shadow}, 0 0 0 1px rgba(10,20,100,.06);
  font-size:11px; font-weight:600; color:${CQ.ink};
  white-space:nowrap; overflow:hidden;
  cursor:grab;
}
.cq-fab:active{ cursor:grabbing; }

.cq-scrim{ position:fixed; inset:0; z-index:200; background:rgba(10,20,100,.28); backdrop-filter:blur(6px); display:flex; }
.cq-scrim.mobile{ align-items:flex-end; justify-content:center; }
.cq-scrim.desktop{ align-items:center; justify-content:center; padding:20px; }
.cq-sheet{ position:relative; width:100%; overflow:hidden; display:flex; flex-direction:column; background:${CQ.sheet}; color:${CQ.ink}; }
.cq-sheet.mobile{ border-radius:28px 28px 0 0; max-height:80vh; padding-bottom:env(safe-area-inset-bottom); }
.cq-sheet.desktop{ max-width:400px; border-radius:28px; max-height:80vh; box-shadow:0 24px 60px -12px ${CQ.shadow}; }
.cq-body{ flex:1 1 auto; overflow-y:auto; min-height:0; padding:6px 18px 18px; }
.cq-title{ font-size:22px; font-weight:800; margin:0; }
.cq-sub{ font-size:13px; color:${CQ.body}; line-height:1.5; margin:4px 0 16px; }
.cq-list{ display:flex; flex-direction:column; gap:8px; }
.cq-row{ display:flex; align-items:center; gap:12px; width:100%; background:#fff; border-radius:20px; border:2px solid transparent;
  padding:11px 14px; text-align:left; transition:border-color .13s, transform .1s; }
.cq-row:active{ transform:scale(0.99); }
.cq-row.on{ border-color:${CQ.blue}; }
.cq-row-ic{ width:40px; height:40px; border-radius:50%; background:${CQ.chip}; display:flex; align-items:center; justify-content:center; flex-shrink:0;
  font-weight:800; font-size:15px; color:${CQ.ink}; transition:background .13s, color .13s; }
.cq-row.on .cq-row-ic{ background:${CQ.blue}; color:#fff; }
.cq-row-title{ font-size:15px; font-weight:600; color:${CQ.ink}; }
.cq-row-code{ font-size:12px; color:${CQ.body}; }
.cq-row-check{ width:24px; height:24px; border-radius:50%; background:${CQ.blue}; display:flex; align-items:center; justify-content:center; flex-shrink:0; }
.cq-close{ position:absolute; top:12px; right:12px; width:36px; height:36px; border-radius:50%; background:#fff; display:flex; align-items:center; justify-content:center; box-shadow:0 2px 8px -2px ${CQ.shadow}; z-index:1; }
.cq-note{ font-size:13px; color:${CQ.body}; text-align:center; padding:20px 0; }
@media (prefers-reduced-motion: reduce){ .cq *{ transition:none !important; } }
`;

  function useIsMobile(breakpoint = 700) {
    const [isMobile, setIsMobile] = useState(
      typeof window !== "undefined" ? window.innerWidth < breakpoint : false
    );
    useEffect(() => {
      const onResize = () => setIsMobile(window.innerWidth < breakpoint);
      window.addEventListener("resize", onResize);
      return () => window.removeEventListener("resize", onResize);
    }, [breakpoint]);
    return isMobile;
  }

  const DragHandle: React.FC = () => (
    <div style={{ display: "flex", justifyContent: "center", paddingTop: 12 }}>
      <div style={{ width: 40, height: 5, borderRadius: 999, background: CQ.handle }} />
    </div>
  );

  function readCache(): CurrencyInfo | null {
    try {
      const raw = localStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (!parsed?.code || typeof parsed.rate !== "number" || typeof parsed.ts !== "number") return null;
      if (Date.now() - parsed.ts > CACHE_TTL_MS) return null;
      return { code: parsed.code, rate: parsed.rate };
    } catch {
      return null;
    }
  }

  function writeCache(info: CurrencyInfo) {
    try {
      localStorage.setItem(CACHE_KEY, JSON.stringify({ ...info, ts: Date.now() }));
    } catch {
      /* ignore quota errors */
    }
  }

  /** IP-based country -> currency lookup. No key, no permission prompt. */
  async function detectCurrencyCode(): Promise<string> {
    try {
      const res = await fetch("https://ipwho.is/");
      const data = await res.json();
      if (data?.success !== false && typeof data?.currency === "string" && data.currency.length === 3) {
        return data.currency.toUpperCase();
      }
    } catch {
      /* fall through to backup */
    }
    try {
      const res = await fetch("https://ip-api.com/json/?fields=currency");
      const data = await res.json();
      if (typeof data?.currency === "string" && data.currency.length === 3) {
        return data.currency.toUpperCase();
      }
    } catch {
      /* give up, caller falls back to EUR */
    }
    return "EUR";
  }

  /** Free EUR -> target exchange rate, from the same bulk source as the picker list. */
  async function fetchRate(targetCode: string): Promise<number> {
    if (targetCode === "EUR") return 1;
    const rates = await loadAllRates();
    const rate = rates[targetCode];
    if (typeof rate === "number" && rate > 0) return rate;
    // Rare: open.er-api's bulk response didn't include this one code — try Frankfurter
    // directly for just this currency before giving up.
    try {
      const res = await fetch(`https://api.frankfurter.dev/v1/latest?base=EUR&symbols=${targetCode}`);
      const data = await res.json();
      const r = data?.rates?.[targetCode];
      if (typeof r === "number" && r > 0) return r;
    } catch {
      /* give up */
    }
    return 1; // if every lookup fails, don't distort prices — treat as 1:1
  }

  function parseEuroNumber(raw: string): number {
    // Normalize "1,234.56" / "1.234,56" / "19,99" / "19.99" into a plain float.
    const hasComma = raw.includes(",");
    const hasDot = raw.includes(".");
    let normalized = raw;
    if (hasComma && hasDot) {
      // whichever separator appears last is the decimal separator
      normalized = raw.lastIndexOf(",") > raw.lastIndexOf(".")
        ? raw.replace(/\./g, "").replace(",", ".")
        : raw.replace(/,/g, "");
    } else if (hasComma) {
      normalized = raw.replace(",", ".");
    }
    const n = parseFloat(normalized);
    return Number.isFinite(n) ? n : 0;
  }

  const Provider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const isMobile = useIsMobile();
    const [currency, setCurrency] = useState("EUR");
    const [rate, setRate] = useState(1);
    const [ready, setReady] = useState(false);
    const [open, setOpen] = useState(false);

    // ── swipeable edge tab: sits mostly off-screen at rest (only a sliver
    // showing on the left edge), swipe right to pull it fully into view,
    // swipe left (or releasing without pulling far enough) tucks it back away. ──
    const TAB_WIDTH = 108;
    const TAB_PEEK = 24; // how much stays visible when tucked away
    const TAB_HIDE_OFFSET = TAB_WIDTH - TAB_PEEK;
    const [pulled, setPulled] = useState(false);
    const dragStartX = useRef(0);
    const [dragOffset, setDragOffset] = useState(0);
    const [isDragging, setIsDragging] = useState(false);

    const handleTabPointerDown = (e: React.PointerEvent) => {
      dragStartX.current = e.clientX;
      setIsDragging(true);
      (e.target as Element).setPointerCapture?.(e.pointerId);
    };
    const handleTabPointerMove = (e: React.PointerEvent) => {
      if (!isDragging) return;
      const delta = e.clientX - dragStartX.current; // positive = dragging right (pulling out)
      const base = pulled ? 0 : -TAB_HIDE_OFFSET;
      const next = Math.max(-TAB_HIDE_OFFSET, Math.min(0, base + delta));
      setDragOffset(next);
    };
    const handleTabPointerUp = () => {
      if (!isDragging) return;
      setIsDragging(false);
      const shouldPull = dragOffset > -TAB_HIDE_OFFSET / 2;
      setPulled(shouldPull);
      setDragOffset(0);
    };
    const tabX = isDragging ? dragOffset : (pulled ? 0 : -TAB_HIDE_OFFSET);

    const handleTabTap = () => {
      if (!pulled) { setPulled(true); return; }
      setOpen(true);
    };

    const [currencyList, setCurrencyList] = useState<CurrencyListItem[]>([]);
    const [loadingList, setLoadingList] = useState(true);
    const [listError, setListError] = useState<string | null>(null);

    // Pull the currency list straight from Frankfurter — no hardcoded array.
    useEffect(() => {
      let cancelled = false;
      (async () => {
        try {
          const items = await fetchCurrencyList();
          if (!cancelled) setCurrencyList(items);
        } catch {
          if (!cancelled) setListError("Couldn't load currencies.");
        } finally {
          if (!cancelled) setLoadingList(false);
        }
      })();
      return () => { cancelled = true; };
    }, []);

    // ── detect once per day, cached — unless the visitor already picked one manually ──
    useEffect(() => {
      let cancelled = false;
      (async () => {
        const manual = localStorage.getItem(MANUAL_KEY);
        if (manual) {
          const r = await fetchRate(manual);
          if (!cancelled) { setCurrency(manual); setRate(r); setReady(true); }
          return;
        }
        const cached = readCache();
        if (cached) {
          if (!cancelled) { setCurrency(cached.code); setRate(cached.rate); setReady(true); }
          return;
        }
        const code = await detectCurrencyCode();
        const r = await fetchRate(code);
        if (!cancelled) {
          setCurrency(code);
          setRate(r);
          setReady(true);
        }
        writeCache({ code, rate: r });
      })();
      return () => { cancelled = true; };
    }, []);

    // Visitor picking a currency from the floating button — remembered from now on.
    const selectCurrency = useCallback(async (code: string) => {
      localStorage.setItem(MANUAL_KEY, code);
      setOpen(false);
      const r = await fetchRate(code);
      setCurrency(code);
      setRate(r);
      setReady(true);
    }, []);

    const convert = useCallback((eurAmount: number) => eurAmount * rate, [rate]);

    const format = useCallback(
      (eurAmount: number) => {
        try {
          return new Intl.NumberFormat(navigator.language || "en-US", {
            style: "currency",
            currency,
            maximumFractionDigits: 2,
          }).format(convert(eurAmount));
        } catch {
          return `€${eurAmount.toFixed(2)}`;
        }
      },
      [currency, convert]
    );

    // ---------------------------------------------------------------------
    // Global, automatic DOM conversion — mirrors LanguageProvider's approach:
    // walk the tree once ready, then watch for new content.
    // ---------------------------------------------------------------------
    const rootRef = useRef<HTMLDivElement>(null);
    const observerRef = useRef<MutationObserver | null>(null);
    // node -> { original: last-seen "€.." source text, written: what WE last wrote to it }.
    // Tracking `written` lets us tell "React just changed this price" apart from "this is
    // our own converted text from before" — without it, a page whose price recalculates
    // (toggles, dropdowns, etc.) would keep re-showing the FIRST amount it ever saw.
    const originals = useRef<WeakMap<Text, CurrencyOriginalEntry>>(new WeakMap());
    const debounceRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    const shouldSkip = (el: Element | null): boolean => {
      while (el) {
        if (el.hasAttribute?.("data-no-currency") || el.hasAttribute?.("data-no-translate")) return true;
        if (["SCRIPT", "STYLE", "NOSCRIPT", "TEXTAREA", "INPUT"].includes(el.tagName)) return true;
        el = el.parentElement;
      }
      return false;
    };

    const collectTextNodes = (root: Node): Text[] => {
      const isAcceptable = (node: Node) => {
        const text = node.nodeValue;
        return !!text && text.includes("€") && !shouldSkip((node as Text).parentElement);
      };
      if (root.nodeType === Node.TEXT_NODE) return isAcceptable(root) ? [root as Text] : [];
      const nodes: Text[] = [];
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
        acceptNode: (n) => (isAcceptable(n) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT),
      });
      let n: Node | null;
      while ((n = walker.nextNode())) nodes.push(n as Text);
      return nodes;
    };

    const withMutationsPaused = (fn: () => void) => {
      observerRef.current?.disconnect();
      fn();
      if (rootRef.current) {
        observerRef.current?.observe(rootRef.current, { childList: true, subtree: true, characterData: true });
      }
    };

    const convertNode = useCallback(
      (node: Text) => {
        // Currency amounts are never translatable content — tag the parent once so
        // LanguageProvider's own MutationObserver permanently skips it. Without this,
        // the two providers can end up rewriting the same text back and forth
        // (translate -> reconvert -> translate...), which shows up as the page's
        // cards visibly jittering as their text length keeps changing.
        const parent = node.parentElement;
        if (parent && !parent.hasAttribute("data-no-translate")) {
          parent.setAttribute("data-no-translate", "true");
        }

        const current: string = node.nodeValue ?? "";
        const entry: CurrencyOriginalEntry | undefined = originals.current.get(node);

        // If the node's text doesn't match what WE last wrote there, something else (React,
        // re-rendering with a recalculated price) changed it since — treat that as the new
        // "original" euro source rather than trusting a possibly stale cached value.
        const original: string = !entry || entry.written !== current ? current : entry.original;

        if (currency === "EUR") {
          // Local visitor / detection failed — leave the (now-current) €-text untouched,
          // just keep the tracking entry in sync so future re-renders are detected correctly.
          originals.current.set(node, { original, written: original });
          if (node.nodeValue !== original) node.nodeValue = original;
          return;
        }

        const replaced: string = original.replace(EURO_PRICE_RE, (_match, num: string) => format(parseEuroNumber(num)));
        originals.current.set(node, { original, written: replaced });
        if (node.nodeValue !== replaced) node.nodeValue = replaced;
      },
      [currency, format]
    );

    const runConversion = useCallback(
      (root: Node) => {
        const nodes = collectTextNodes(root);
        if (nodes.length === 0) return;
        withMutationsPaused(() => nodes.forEach(convertNode));
      },
      [convertNode]
    );

    // Re-run over the whole tree once detection resolves (or currency changes for any reason).
    useEffect(() => {
      if (ready && rootRef.current) runConversion(rootRef.current);
    }, [ready, currency, rate, runConversion]);

    // Watch for new content — route changes, modals, async data — and convert it too.
    useEffect(() => {
      const root = rootRef.current;
      if (!root) return;
      const observer = new MutationObserver((mutations) => {
        if (debounceRef.current) clearTimeout(debounceRef.current);
        debounceRef.current = setTimeout(() => {
          mutations.forEach((m) => {
            if (m.type === "characterData") runConversion(m.target);
            else m.addedNodes.forEach((node) => runConversion(node));
          });
        }, 120);
      });
      observerRef.current = observer;
      observer.observe(root, { childList: true, subtree: true, characterData: true });
      return () => observer.disconnect();
    }, [runConversion]);
    // ---------------------------------------------------------------------

    useEffect(() => {
      if (!open) return;
      const onKey = (e: KeyboardEvent) => { if (e.key === "Escape") setOpen(false); };
      window.addEventListener("keydown", onKey);
      const prev = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      return () => { window.removeEventListener("keydown", onKey); document.body.style.overflow = prev; };
    }, [open]);

    const current = currencyList.find((c) => c.code === currency);

    return (
      <CurrencyContext.Provider value={{ currency, rate, ready, convert, format }}>
        <div ref={rootRef}>{children}</div>

        <div className="cq" data-no-currency data-no-translate>
          <style>{CQ_CSS}</style>

          <div
            className="cq-tab-wrap"
            style={{
              transform: `translateY(-50%) translateX(${tabX}px)`,
              transition: isDragging ? "none" : "transform .22s cubic-bezier(.2,.85,.3,1.3)",
            }}
          >
            <button
              type="button"
              className="cq-fab"
              onClick={handleTabTap}
              onPointerDown={handleTabPointerDown}
              onPointerMove={handleTabPointerMove}
              onPointerUp={handleTabPointerUp}
              onPointerCancel={handleTabPointerUp}
              aria-label="Change currency"
            >
              <Coins size={13} color={CQ.ink} style={{ flexShrink: 0 }} />
              <span>{current?.code ?? currency}</span>
            </button>
          </div>

          <AnimatePresence>
            {open && (
              <motion.div
                className={`cq-scrim ${isMobile ? "mobile" : "desktop"}`}
                initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
                onClick={() => setOpen(false)}
              >
                <motion.div
                  role="dialog" aria-modal="true" aria-labelledby="cq-title"
                  className={`cq-sheet ${isMobile ? "mobile" : "desktop"}`}
                  onClick={(e: React.MouseEvent) => e.stopPropagation()}
                  initial={isMobile ? { y: "100%" } : { opacity: 0, scale: 0.93, y: 16 }}
                  animate={isMobile ? { y: 0 } : { opacity: 1, scale: 1, y: 0 }}
                  exit={isMobile ? { y: "100%" } : { opacity: 0, scale: 0.94, y: 12 }}
                  transition={{ type: "spring", stiffness: 320, damping: 30 }}
                >
                  {isMobile ? <DragHandle /> : (
                    <button type="button" className="cq-close" onClick={() => setOpen(false)} aria-label="Close">
                      <X size={16} strokeWidth={2.6} color={CQ.ink} />
                    </button>
                  )}

                  <div className="cq-body" style={{ paddingTop: isMobile ? 14 : 22 }}>
                    <h2 id="cq-title" className="cq-title">Select currency</h2>
                    <p className="cq-sub">Prices will show converted from EUR at today's rate.</p>

                    {loadingList && <p className="cq-note">Loading currencies…</p>}
                    {listError && <p className="cq-note">{listError}</p>}

                    <div className="cq-list">
                      {!loadingList && currencyList.map((c) => {
                        const active = c.code === currency;
                        return (
                          <button
                            key={c.code}
                            type="button"
                            className={`cq-row${active ? " on" : ""}`}
                            aria-pressed={active}
                            onClick={() => selectCurrency(c.code)}
                          >
                            <span className="cq-row-ic">{c.symbol}</span>
                            <span style={{ flex: 1 }}>
                              <div className="cq-row-title">{c.name}</div>
                              <div className="cq-row-code">{c.code}</div>
                            </span>
                            {active && (
                              <span className="cq-row-check"><Check size={14} strokeWidth={3} color="#fff" /></span>
                            )}
                          </button>
                        );
                      })}
                    </div>
                  </div>
                </motion.div>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </CurrencyContext.Provider>
    );
  };

  const useCurrency = () => {
    const ctx = useContext(CurrencyContext);
    if (!ctx) throw new Error("useCurrency must be used within a CurrencyProvider");
    return ctx;
  };

  return Object.assign(Provider, { useCurrency });
})();